import { render, staticRenderFns } from "./Actualizar-precios.vue?vue&type=template&id=42194688&scoped=true"
import script from "./Actualizar-precios.vue?vue&type=script&lang=js"
export * from "./Actualizar-precios.vue?vue&type=script&lang=js"
import style0 from "./Actualizar-precios.vue?vue&type=style&index=0&id=42194688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42194688",
  null
  
)

export default component.exports